/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PortfolioTypeEnum,
    PortfolioTypeEnumFromJSON,
    PortfolioTypeEnumFromJSONTyped,
    PortfolioTypeEnumToJSON,
} from './PortfolioTypeEnum';

/**
 * 
 * @export
 * @interface CreatePortfolioDto
 */
export interface CreatePortfolioDto {
    /**
     * 
     * @type {PortfolioTypeEnum}
     * @memberof CreatePortfolioDto
     */
    type: PortfolioTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePortfolioDto
     */
    includedInSummary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioDto
     */
    iconName: CreatePortfolioDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioDto
     */
    colorName: CreatePortfolioDtoColorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioDto
     */
    name: string;
}

/**
* @export
* @enum {string}
*/
export enum CreatePortfolioDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum CreatePortfolioDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function CreatePortfolioDtoFromJSON(json: any): CreatePortfolioDto {
    return CreatePortfolioDtoFromJSONTyped(json, false);
}

export function CreatePortfolioDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePortfolioDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PortfolioTypeEnumFromJSON(json['type']),
        'includedInSummary': !exists(json, 'includedInSummary') ? undefined : json['includedInSummary'],
        'currencyCode': json['currencyCode'],
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'name': json['name'],
    };
}

export function CreatePortfolioDtoToJSON(value?: CreatePortfolioDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PortfolioTypeEnumToJSON(value.type),
        'includedInSummary': value.includedInSummary,
        'currencyCode': value.currencyCode,
        'iconName': value.iconName,
        'colorName': value.colorName,
        'name': value.name,
    };
}

